<template>
  <div class="simple-header-container" @click="$emit('click')">
    <span class="simple-header-icon">&ShortLeftArrow;</span>
    <span v-if="label" class="simple-header-label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'SimpleHeader',
  props: {
    label: String
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.simple-header-container {
  text-align: left;
  margin-bottom: 20px;
  cursor: pointer;
  width: 75%;
  margin-left: 10px;
  margin-top: 10px;

  .simple-header-icon {
    display: inline-block;
    height: 12px;
    width: 12px;
    text-align: center;
  }

  .simple-header-label {
    margin-left: 8px;
    font-size: 13px;
    color: $font-color;
    // text-decoration: underline;
    font-weight: 900;
  }
}
</style>
